<template>
  <span>
    <modal id="care-overview-modal">
      <template v-slot:header>
        <h3 class="modal-title">Verzorging losstaand modal</h3>
      </template>
      <template v-slot:body>
          <span
            v-for="idChild in childIds"
            :key="idChild"
          >
              <div
                  v-if="getItemsFilteredByChild(getChild(idChild), groupInstructions).length > 0"
                  class="list-group mb-1"
              >
                  <div
                      :key="index"
                      v-for="(instruction, index) in getItemsFilteredByChild(getChild(idChild), groupInstructions)"
                      class="list-group-item"
                  >
                    <div class="row">
                        <div class="col-3">
                          <icon
                            v-if="instruction.priority === '0'"
                            name="care-prio-normal"
                          ></icon>
                          <icon
                            v-if="instruction.priority === '1'"
                            name="care-prio-high"
                          ></icon>
                        </div>
                        <div class="col-9">
                            <p class="m-0 fw-bold">
                              <span v-if="getChild(idChild) !== false">
                                {{ getChild(idChild).full_name }}
                              </span>
                              -
                              {{ instruction.title }}
                            </p>
                            <p>
                            <span v-if="instruction.modified_at" class="text-muted fst-italic">
                              Laatst bewerkt op {{ this.$moment(instruction.modified_at).format('dddd D MMMM YYYY') }}
                            </span>
                            <span v-else class="text-muted fst-italic">
                              Aangemaakt op {{ this.$moment(instruction.created_at).format('dddd D MMMM YYYY') }}
                            </span>
                          </p>
                          <p>
                            {{ instruction.body }}
                          </p>
                        </div>
                    </div>
                  </div>
              </div>
            </span>
      </template>
      <template v-slot:footer>
        <div>
          <button
            type="button"
            class="btn btn-outline-info"
            @click="onClose()"
          >
            Sluiten
          </button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import Icon from '@/components/Icon'
import Modal from '@/components/Modal'
export default {
  name: 'care-overview-modal',
  components: {
    Modal,
    Icon
  },
  props: {
    childIds: {
      type: Array,
      required: true
    }
  },
  computed: {
    groupInstructions () {
      return this.$store.getters.groupInstructions
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    }
  }
}
</script>
